import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AddEntityButton from "../../../components/AddEntityButton";
import OptionFormModal from "./OptionFormModal";

const AddOption = ({
  reloadCallback,
  onSuccess,
  iconOnly = true,
  buttonProps = {},
}) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  const handleSuccess = (response, values) => {
    reloadCallback?.(response, values);
    onSuccess?.(response, values);
  };

  return (
    <>
      <AddEntityButton
        iconOnly={iconOnly}
        buttonProps={{
          ...buttonProps,
          key: "open-add-option-modal",
          onClick: () => setModalOpen(true),
        }}
      >
        + {t("option_add")}
      </AddEntityButton>

      <OptionFormModal
        open={modalOpen}
        mode="add"
        onClose={() => setModalOpen(false)}
        onSuccess={handleSuccess}
      />
    </>
  );
};

export default AddOption;
